import React, { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import BlankIcon from "../../../assets/img/icn-_blank-white.svg";
import PDFIcon from "../../../assets/img/icn-pdf.svg";
import styles from "./Link.module.css";
import { AdjustProps } from "../../Adjust/Adjust";
import adjustStyles from "../../Adjust/Adjust.module.css";
import { config } from "../../config/Config";
import { HashLink } from "react-router-hash-link";

const telHrefPrefix = "tel:";

export enum LinkIcon {
  BLANK = "blank",
  PDF = "pdf",
  NONE = "none",
}

export interface LinkProps {
  href?: string;
  target?: "_blank" | "_self";
  icon?: LinkIcon;
  adjust?: Pick<AdjustProps, "align">;
  children: ReactNode;
  isSmoothScroll?: boolean;
  activeForAgent?: boolean;
}

export const Link = (props: LinkProps) => {
  const {
    href,
    children,
    target,
    adjust,
    icon = target === "_blank" ? LinkIcon.BLANK : LinkIcon.NONE,
    isSmoothScroll = true,
    activeForAgent = false,
  } = props;
  const componentStyles = adjust && adjustStyles[`align${adjust?.align}`];

  if (config.agent && !activeForAgent) {
    return (
      <a
        onClick={(e) => e.preventDefault()}
        href={href}
        className={componentStyles}
      >
        {icon === LinkIcon.BLANK && (
          <img
            src={BlankIcon}
            width="12"
            height="10"
            alt="新しいウィンドウで開く"
            className={`icn-_blank`}
          />
        )}
        {icon === LinkIcon.PDF && (
          <img
            src={PDFIcon}
            width="12"
            height="10"
            alt="PDFファイル"
            className={`icn-pdf`}
          />
        )}
        {children}
      </a>
    );
  }

  const url = activeForAgent ? href : "";

  if (!url) {
    return (
      <a href={url} className={componentStyles}>
        {children}
      </a>
    );
  }

  const isHashLink = url.includes("#");
  const isTelephone = url.startsWith(telHrefPrefix);
  const isExternalLink = /https?:\/\//g.test(url);

  if (isTelephone) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <a data-tel-href={url} target={target}>
        {children}
      </a>
    );
  }

  if (isExternalLink) {
    return (
      <a href={url} className={componentStyles} target={target}>
        {icon === LinkIcon.BLANK && (
          <img
            src={BlankIcon}
            width="12"
            height="10"
            alt="新しいウィンドウで開く"
            className={`icn-_blank`}
          />
        )}
        {icon === LinkIcon.PDF && (
          <img
            src={PDFIcon}
            width="12"
            height="10"
            alt="PDFファイル"
            className={`icn-pdf`}
          />
        )}
        {children}
      </a>
    );
  }

  if (isHashLink) {
    return (
        <HashLink to={url} scroll={(el) => {}}>
          <>
            {icon === LinkIcon.BLANK && (
              <img
                src={BlankIcon}
                width="12"
                height="10"
                alt="新しいウィンドウで開く"
                className={`icn-_blank`}
              />
            )}
            {icon === LinkIcon.PDF && (
              <img
                src={PDFIcon}
                width="12"
                height="10"
                alt="PDFファイル"
                className={`icn-pdf`}
              />
            )}
            {children}
          </>
        </HashLink>
    );
  }

  return (
    <RouterLink to={url} target={target} className={componentStyles}>
      <>
        {icon === LinkIcon.BLANK && (
          <img
            src={BlankIcon}
            width="12"
            height="10"
            alt="新しいウィンドウで開く"
            className={`icn-_blank`}
          />
        )}
        {icon === LinkIcon.PDF && (
          <img
            src={PDFIcon}
            width="12"
            height="10"
            alt="PDFファイル"
            className={`icn-pdf`}
          />
        )}
        {children}
      </>
    </RouterLink>
  );
};

export const ModLink = (props: LinkProps) => {
  return (
    <p className={styles["mod-link"]}>
      <Link {...props} />
    </p>
  );
};
